import { render, staticRenderFns } from "./SkyReview.vue?vue&type=template&id=7b757567&scoped=true&"
import script from "./SkyReview.vue?vue&type=script&lang=js&"
export * from "./SkyReview.vue?vue&type=script&lang=js&"
import style0 from "./SkyReview.vue?vue&type=style&index=0&id=7b757567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b757567",
  null
  
)

export default component.exports